export const apiObj = {
  leftList:"e6f93a02-084d-4b68-9116-670b93e179af/query?parameters=%5B%5D",
  rightList:"06492f7e-1817-48d1-9c1d-4e1f829b124d/query?parameters=%5B%5D",
  mapApi:"a385aa08-806e-43b5-b13d-204668ec053c/query?parameters=%5B%5D"
}